import { BrandName } from '@seek/je-shared-data/lib/types/brand';
import { getFeatures } from '@store/config';
import { useAppSelector } from '@store/hooks';

export const useLimitBusinessCountryCode = (brand: BrandName) => {
  const features = useAppSelector(getFeatures());

  return Boolean(features?.limitBusinessCountryCodeForBrand[brand]);
};
